<template>
	<div class="box query">
		<el-form :model="query" ref="queryRef" :inline="true">
			<el-form-item>
				<el-input v-model="query.title" placeholder="题目标题" clearable @keyup.enter="onSearch"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="onSearch" icon="search">查询</el-button>
			</el-form-item>
		</el-form>
	</div>
  <div class="box data">
	<el-table
		ref="multipleTable"
		v-loading="loading"
		:data="tableData.data"
		row-key="id"
		border
		stripe
		style="width: 100%; height: 400px"
		:header-cell-style="{ background: 'var(--el-fill-color-light)' }"
		@selection-change="onSelectionChange"
	>
		<el-table-column
			label=""
			reserve-selection
			type="selection"
			width="55"
			fixed="left"
		></el-table-column>
		<dc-table-column v-for="item in tableProps" :key="item" :item="item"></dc-table-column>
	</el-table>
  </div>
	<el-pagination
		v-if="total > 0"
		layout="prev, pager, next"
		:default-page-size="20"
		:total="total"
		@change="paginationChange"
	/>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { useBaseMixins } from '@/views/base_mixins.js'
import { getmList } from '@/api/kaijiang/dataList.js'
const model = defineModel({ type: Array, default: [] })
const { query, loading, tableData, selectionNodes } = useBaseMixins()
const total = ref(0)
const page = ref(1)
const multipleTable = ref(null)
const allowMult = ref(false)
const tableProps = ref([
	{
		label: '标题',
		prop: 'title',
		sortable: true,
		tooltip: true
		// fixed: 'left'
	},
	{
		label: '副标题',
		prop: 'title_vice',

		tooltip: true
	},
	{
		label: '地区',
		prop: 'rename'
	},
	{
		label: '公职类型',
		prop: 'po_name'
	}
])

/**
 * 选择
 * @param nodes
 */
function onSelectionChange(nodes) {
	selectionNodes.value = nodes
	model.value = nodes
}
const allData = ref([])
const getData = async (e) => {
	loading.value = true
	const res = await getmList(e)
	if (res.code === 1) {
		tableData.value.data = res.data.data
		loading.value = false
		total.value = res.data.total
		allData.value = JSON.parse(JSON.stringify(model.value))
		if (model.value.length > 0 && !allowMult.value) {
			model.value.forEach((item) => {
				const row = tableData.value.data.find((f) => f.id == item)
				if (row != undefined) {
					multipleTable.value.toggleRowSelection(row, true)
				}
			})
		}
	}
}
const getData2 = async (e) => {
	loading.value = true
	const res = await getmList(e)
	if (res.code === 1) {
		tableData.value.data = res.data.data
		loading.value = false
		total.value = res.data.total
		if (allData.value.length > 0 && !allowMult.value) {
			allData.value.forEach((item) => {
				const row = tableData.value.data.find((f) => f.id == item)
				if (row != undefined) {
					multipleTable.value.toggleRowSelection(row, true)
				}
			})
		}
		allowMult.value = true
	}
}
// 页数修改
const paginationChange = (val) => {
	page.value = val
	query.value.page = val
	getData2(query.value)
}
const onSearch = () => {
	query.value.page = 1
	getData(query.value)
}
onMounted(() => {
	allowMult.value = false
	getData({ page: page.value })
})

onUnmounted(() => {})
</script>

<style scoped>
.query {
	margin-bottom: 20px;
}
</style>
